export default class Carousel {
    constructor() {
        const elements = document.querySelectorAll(".js-carousel");
        if (elements.length === 0) return;
        if (elements.length === 1 && elements.childElementCount === 1) return;

        this.createInstances(elements);
    }

    async createInstances(elements) {
        const {
            default: Carousel
        } = await import(/* webpackChunkName: "carousel" */ "../classes/carousel/Carousel");
        const {
            default: Lightbox
        } = await import(/* webpackChunkName: "lightbox" */ "../classes/Lightbox");

        for (let i = 0; i < elements.length; i++) {
            const slideCount = elements[i].childElementCount;
            
            if (slideCount > 1) {
                // Nhiều hơn 1 slide: khởi tạo Carousel (sẽ tự động khởi tạo Lightbox nếu có data-lightbox)
                new Carousel(elements[i]);
            } else if (slideCount === 1 && elements[i].hasAttribute("data-lightbox")) {
                // Chỉ có 1 slide nhưng có data-lightbox: khởi tạo Lightbox trực tiếp (không tạo Carousel)
                new Lightbox(elements[i]);
            }
        }
    }
}
